/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateRentalDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivRentalControllerAccessParamsGen,
  MrfiktivRentalControllerGetParamsGen,
  MrfiktivRentalViewModelGen,
  MrfiktivUpdateRentalDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Rental<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags rental
   * @name RentalControllerCreate
   * @summary (Rental - CREATE) Create a Rental
   * @request POST:/partner/{partnerId}/rental
   * @secure
   * @response `201` `MrfiktivRentalViewModelGen` The created rental
   */
  rentalControllerCreate = (partnerId: string, data: MrfiktivCreateRentalDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivRentalViewModelGen, any>({
      path: `/partner/${partnerId}/rental`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags rental
   * @name RentalControllerGet
   * @summary (Rental - READ) Get all rentals
   * @request GET:/partner/{partnerId}/rental
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivRentalViewModelGen)[] })`
   */
  rentalControllerGet = ({ partnerId, ...query }: MrfiktivRentalControllerGetParamsGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivRentalViewModelGen[] }, any>({
      path: `/partner/${partnerId}/rental`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags rental
   * @name RentalControllerGetOne
   * @summary (Rental - READ) Get a rental
   * @request GET:/partner/{partnerId}/rental/{rentalId}
   * @secure
   * @response `200` `MrfiktivRentalViewModelGen` The rental
   */
  rentalControllerGetOne = (partnerId: string, rentalId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivRentalViewModelGen, any>({
      path: `/partner/${partnerId}/rental/${rentalId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags rental
   * @name RentalControllerUpdate
   * @summary (Rental - UPDATE) Updates a rental
   * @request PATCH:/partner/{partnerId}/rental/{rentalId}
   * @secure
   * @response `201` `MrfiktivRentalViewModelGen` The updated rental
   */
  rentalControllerUpdate = (
    partnerId: string,
    rentalId: string,
    data: MrfiktivUpdateRentalDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRentalViewModelGen, any>({
      path: `/partner/${partnerId}/rental/${rentalId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags rental
   * @name RentalControllerDelete
   * @summary (Rental - DELETE) Deletes a rental
   * @request DELETE:/partner/{partnerId}/rental/{rentalId}
   * @secure
   * @response `200` `MrfiktivRentalViewModelGen` The deleted rental
   */
  rentalControllerDelete = (partnerId: string, rentalId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivRentalViewModelGen, any>({
      path: `/partner/${partnerId}/rental/${rentalId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags rental
   * @name RentalControllerAccess
   * @summary (SCT) Get a rental
   * @request GET:/partner/{partnerId}/rental/{rentalId}/access
   * @secure
   * @response `200` `MrfiktivRentalViewModelGen` The found record
   * @response `400` `void` Bad Request.
   * @response `403` `void` Forbidden.
   * @response `404` `void` Report not found.
   */
  rentalControllerAccess = (
    { partnerId, rentalId, ...query }: MrfiktivRentalControllerAccessParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRentalViewModelGen, void>({
      path: `/partner/${partnerId}/rental/${rentalId}/access`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags rental
   * @name RentalControllerUpdateStatus
   * @summary (RENTAL - UPDATE) Update status of a rental as a partner
   * @request PATCH:/partner/{partnerId}/rental/{rentalId}/status
   * @secure
   * @response `200` `MrfiktivRentalViewModelGen` The updated rental
   */
  rentalControllerUpdateStatus = (partnerId: string, rentalId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivRentalViewModelGen, any>({
      path: `/partner/${partnerId}/rental/${rentalId}/status`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params
    });
}
